import styled from 'styled-components';

export const Wrapper = styled.div`
	overflow-y: auto;
	max-height: 60vh;
	display: flex;
	justify-content: center;
`;